<div class="or-p-32-px">
  <div class="modal-scroll-area">
    <div class="or-d-flex or-justify-content-center">
      <span class="or-head-xl or-mb-16-px or-text-align-center">{{ header }}</span>
    </div>
    <div class="or-d-flex or-justify-content-center or-text-align-center or-mb-20-px">
      <span class="or-text-md">{{ message }}</span>
    </div>

    <div class="or-mb-24-px">
      <ng-template #componentHost></ng-template>
    </div>
  </div>

  <div class="or-d-flex">
    <button class="button-secondary-style or-h-48-px or-w-60-pc or-head-sm or-mr-8-px" (click)="closeModal()">
      {{ btnCancel }}
    </button>
    <button
      class="button-primary-style or-h-48-px or-w-60-pc or-head-sm"
      [disabled]="isOkDisabled"
      [class.disabled-button]="isOkDisabled"
      (click)="handle()">
      {{ btnOk }}
    </button>
  </div>
</div>
